const SCROLL_TRIGGER_POINT = 300;

class ScrollToTop {
  element: HTMLElement;

  constructor(element: HTMLElement) {
    this.element = element;
  }

  init() {
    this.addEventToElement();
    this.listenScrollingEvent();
    this.handleDisplayElement();
  }

  addEventToElement() {
    this.element.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  handleDisplayElement() {
    const currentScroll = window.scrollY;

    if (currentScroll > SCROLL_TRIGGER_POINT) {
      this.element.classList.add('show');
    } else {
      this.element.classList.remove('show');
    }
  }

  listenScrollingEvent() {
    window.addEventListener('scroll', () => this.handleDisplayElement())
  }
}

window.addEventListener('DOMContentLoaded', () => {
  const element = document.querySelector<HTMLElement>('.arjo-m-scroll-to-top');

  if (element) {
    new ScrollToTop(element).init();
  }
});

export {};
